import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from './api-response.interface';
import { UserModelResponse } from './user-model.interface';

export enum ConfigValueTypeEnum {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    OPERATOR = 'OPERATOR',
}

export interface ConfigModelInterface {
    id: number;
    ident: string;
    value: string;
    value_type: ConfigValueTypeEnum;
    mutable: boolean;
    description: string;
    created_at: Date;
    updated_at: Date;
}

export class ConfigModel implements ConfigModelInterface {
    public resolved_value: string;

    constructor(
        public id: number,
        public ident: string,
        public value: string,
        public value_type: ConfigValueTypeEnum,
        public mutable: boolean,
        public description: string,
        public created_at: Date,
        public updated_at: Date,
        public httpClient?: HttpClient
    ) {
        this.resolved_value = this.value;
        if (!this.httpClient) return;
        if (this.value_type == ConfigValueTypeEnum.OPERATOR) {
            this.resolved_value = '...';
            this.getOperator();
        }
    }

    private getOperator() {
        let params = new HttpParams().set('id', this.value);

        this.httpClient!.get<UserModelResponse>('users', {
            params: params,
        }).subscribe((response: UserModelResponse) => {
            if (response.count == 0) return;
            this.resolved_value = response.results[0].email;
        });
    }

    public static factory(
        model: ConfigModelInterface,
        httpClient?: HttpClient
    ) {
        return new ConfigModel(
            model.id,
            model.ident,
            model.value,
            model.value_type,
            model.mutable,
            model.description,
            model.created_at,
            model.updated_at,
            httpClient
        );
    }
}

export type ConfigModelResponse = ApiResponse<ConfigModelInterface>;
